import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, services } from '@/utils'

import button from '@/components/button'

export default function(h) {
  return h(
    button,
    {
      props: {
        icon: icons.file_download,
        mode: buttonModes.flat,
        color: Colors.primary,
        disabled: !this.value.documentId,
        tooltip: this.getTranslate(`${services.invoices}.tooltips.download`)
      },
      on: {
        click: () => {
          this.download()
        }
      }
    }
  )
}
